export default "__VITE_ASSET__4HqDekY6__"